
import { computed, defineComponent, PropType, reactive } from 'vue'

// components
import TheButton from '@/common/components/UI/TheButton/index.vue'

// types
import { VariantT } from '@/core/types/survey.types'
import useNotifications from '@/common/composable/useNotifications'

// realisation
import { surveys } from '@/core/realisations/surveys.realisation'

export default defineComponent({
    components: {
        'the-button': TheButton,
    },
    props: {
        variant: {
            type: Object as PropType<VariantT>,
            required: true,
        },
        count: {
            type: Number,
            default: 0,
        },
        isUpdate: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['deleted', 'update'],
    setup(props, { emit }) {
        const computedPercent = computed(() => {
            if (props.count === 0) return '0%'
            return `${Math.floor((props.variant.answersCount / props.count) * 100).toFixed(2)}%`
        })

        const notifications = useNotifications()

        const state = reactive({
            is_loading: false,
        })

        const deleteVariant = async () => {
            if (state.is_loading) {
                return
            }

            const answer = confirm(
                `Вы действительно хотите удалить вариант '${props.variant.title}'?`
            )
            if (!answer) {
                return
            }

            try {
                state.is_loading = true
                await surveys.deleteVariant(props.variant.surveyId, props.variant.id)
                emit('deleted', props.variant.id)
            } catch (error) {
                console.error(error)

                notifications.notifyError({
                    error,
                    title: 'При удалении варианта произошла ошибка',
                })
            } finally {
                state.is_loading = false
            }
        }

        const emitUpdate = () => {
            emit('update', props.variant)
        }

        return { computedPercent, state, deleteVariant, emitUpdate }
    },
})
